// Üst çubuktaki açılır menüler (bildirimler, kullanıcı). Şablon: `ref="navbarToggle"` düğme, `ref="navbarMenu"`
// panel (`v-show="navbarDropdownOpen"`). Menünün içine tıklamak açık bırakır, başka her tıklama kapatır — biri
// açılınca diğeri de böyle kapanır. Esc kapatır ve odağı düğmeye döndürür; sayfa değişince kapanır.
export default {
  data() {
    return { navbarDropdownOpen: false };
  },
  watch: {
    '$route.fullPath'() {
      this.navbarDropdownOpen = false;
    }
  },
  mounted() {
    document.addEventListener('click', this.onNavbarDocumentClick);
    document.addEventListener('keydown', this.onNavbarKeyDown);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.onNavbarDocumentClick);
    document.removeEventListener('keydown', this.onNavbarKeyDown);
  },
  methods: {
    toggleNavbarDropdown() {
      this.navbarDropdownOpen = !this.navbarDropdownOpen;
    },
    closeNavbarDropdown() {
      this.navbarDropdownOpen = false;
    },
    onNavbarDocumentClick(event) {
      const { navbarToggle, navbarMenu } = this.$refs;
      if ((navbarToggle && navbarToggle.contains(event.target)) || (navbarMenu && navbarMenu.contains(event.target))) return;
      this.navbarDropdownOpen = false;
    },
    onNavbarKeyDown(event) {
      if (event.key !== 'Escape' || !this.navbarDropdownOpen) return;
      this.navbarDropdownOpen = false;
      const { navbarToggle, navbarMenu } = this.$refs;
      if (navbarToggle && navbarMenu && navbarMenu.contains(document.activeElement)) navbarToggle.focus();
    }
  }
};
